import { render, staticRenderFns } from "./edit_branch.vue?vue&type=template&id=4468e57f&scoped=true"
import script from "./edit_branch.vue?vue&type=script&lang=js"
export * from "./edit_branch.vue?vue&type=script&lang=js"
import style0 from "./edit_branch.vue?vue&type=style&index=0&id=4468e57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4468e57f",
  null
  
)

export default component.exports